var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Utils
import { comparePathsByDepth, getFrom, setIn } from 'ezyvet-fe-helpers';
import { commitPendingChanges } from '../../commitPendingChanges';
import { createObjectPaths, attachGeneratedObjectIdRecursivelyOrReturn } from '../../objectIdentity';
// Types
import { COMMITTED_VALUES } from '../constants';
/**
 * Return values {values} whose committed values are that of {valuesToCommit}.
 * This will also identify any objects that is needed to achieve this
 * @todo: should we preidentify?
 *
 * @template T
 * @param {T} values
 * @param {T} valuesToCommit
 *
 * @return {T}
 */
export var commitGivenValues = function (values, valuesToCommit) {
    var valuesToCommitIdentified = commitPendingChanges(valuesToCommit);
    var valuesIdentified = attachGeneratedObjectIdRecursivelyOrReturn(values);
    // we want to create a new object
    var committedObjectPaths = createObjectPaths(valuesToCommitIdentified);
    var objectPaths = createObjectPaths(valuesIdentified);
    // We want to create a new object, using the committed values on the old object
    var objectIdsByDepth = Object.keys(objectPaths)
        .sort(function (objectIdA, objectIdB) { return (comparePathsByDepth(objectPaths[objectIdA], objectPaths[objectIdB])); });
    var combined = {};
    var path;
    var committedPath;
    var newObject;
    var oldObject;
    objectIdsByDepth.forEach(function (objectId) {
        var _a;
        path = objectPaths[objectId];
        committedPath = committedObjectPaths[objectId];
        newObject = getFrom(valuesIdentified, path);
        if (committedPath !== undefined) {
            oldObject = getFrom(valuesToCommitIdentified, committedPath);
            newObject = __assign(__assign({}, newObject), (_a = {}, _a[COMMITTED_VALUES] = oldObject[COMMITTED_VALUES], _a));
        }
        combined = setIn(combined, path, newObject);
    });
    return combined;
};
//# sourceMappingURL=commitGivenValues.js.map